import i18n from 'i18next';
import { ru, enUS } from 'date-fns/locale';
import type { Locale } from 'date-fns';

const localeMap: Record<string, Locale> = {
  ru,
  en: enUS,
};

export function getDateLocale(): Locale {
  return localeMap[i18n.language] || enUS;
}
